var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbookslight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10101_15484)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3889 33.1669C25.4402 33.1669 32.7778 25.8293 32.7778 16.778C32.7778 7.72667 25.4402 0.38916 16.3889 0.38916C7.33754 0.38916 0 7.72667 0 16.778C0 25.8293 7.33754 33.1669 16.3889 33.1669Z",
    fill: "#0066FF",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10101_15484",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.38916,
    width: 19.9998,
    height: 19.9998,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10101_15484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33364 23.0558C8.87531 23.0558 8.48295 22.8926 8.15657 22.5662C7.83018 22.2399 7.66699 21.8475 7.66699 21.3892V11.3893C7.66699 10.931 7.83018 10.5386 8.15657 10.2122C8.48295 9.88585 8.87531 9.72266 9.33364 9.72266H14.3336L16.0002 11.3893H22.6668C23.1251 11.3893 23.5175 11.5525 23.8439 11.8789C24.1703 12.2053 24.3335 12.5976 24.3335 13.0559V21.3892C24.3335 21.8475 24.1703 22.2399 23.8439 22.5662C23.5175 22.8926 23.1251 23.0558 22.6668 23.0558H9.33364ZM9.33364 21.3892H22.6668V13.0559H15.3127L13.6461 11.3893H9.33364V21.3892Z",
    fill: "#0066FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10101_15484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7778,
    height: 32.7778,
    fill: "white",
    transform: "translate(0 0.38916)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbookslight);
export default __webpack_public_path__ + "static/media/quickbookslight.b4de611d53b334ddf516d2c96a299ad6.svg";
export { ForwardRef as ReactComponent };